import React, { useState, useEffect } from "react";
import { Form } from "antd";
import { FormInstance } from "antd/es/form/Form";
import { DrawerStatusEnum } from "typings/global.types";
import AddInvoices from "../invoice";
import * as S from "./index.styled";

export interface IAddDocuments {
  id: React.Key;
  label: string;
  fieldName?: string;
  hidden: boolean;
  disabled: boolean;
  allowLetters: boolean;
  allowNumbers: boolean;
  allowSpecialCharacters: boolean;
  minCharacters: number;
  maxCharacters: number;
  required: number;
  eventType: number;
  isIntegration: boolean;
  form: FormInstance;
  visibleDrawerViewMode?: DrawerStatusEnum;
}

const AddDocument = ({
  id,
  label,
  fieldName,
  hidden,
  disabled,
  allowLetters,
  allowNumbers,
  allowSpecialCharacters,
  minCharacters,
  maxCharacters,
  required,
  eventType,
  isIntegration,
  form,
  visibleDrawerViewMode,
}: IAddDocuments): JSX.Element => {
  const formFieldName = fieldName || label;
  const [countFields, setCountFields] = useState(1);
  const [initialFields, setInitialFields] = useState<number[]>([]);

  useEffect(() => {
    return () => {
      setInitialFields([]);
      setCountFields(1);
    };
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => {
      const values = form.getFieldValue(formFieldName) || [];
      setCountFields(values.length || 1);
      setInitialFields(values.map((_, index) => index).filter((index) => !!values[index]));
    }, 100);

    return () => clearTimeout(timer);
  }, [form, formFieldName, visibleDrawerViewMode]);

  return (
    <S.FormItem
      hidden={hidden}
      label={label}
      style={S.ProcessesFormItem}
      key={id}
      rules={[
        {
          required: false,
        },
      ]}
    >
      <Form.List name={formFieldName} initialValue={[""]}>
        {(fields, { add, remove }) => {
          return (
            <AddInvoices
              eventType={eventType}
              fields={fields}
              setFieldsCount={setCountFields}
              fieldsCount={countFields}
              add={() => {
                add();
                setCountFields((prev) => prev + 1);
              }}
              remove={(index) => {
                remove(index);
                setCountFields((prev) => prev - 1);
              }}
              disabled={disabled}
              allowLetters={allowLetters}
              allowNumbers={allowNumbers}
              allowSpecialCharacters={allowSpecialCharacters}
              minCharacters={minCharacters}
              maxCharacters={maxCharacters}
              required={required}
              isIntegration={isIntegration}
              label={label}
              form={form}
              initialFields={initialFields}
              visibleDrawerViewMode={visibleDrawerViewMode}
            />
          );
        }}
      </Form.List>
    </S.FormItem>
  );
};

export default AddDocument;
